
import ErrorSerializer from '~/serializer/Error'

export default {
  name: 'GGDefaultSection',
  props: {
    order: {
      type: String,
      default: 'ltr',
    },
    link: {
      type: String,
      default: null,
    },
    linkText: {
      type: String,
      default: null,
    },
    onLinkClick: {
      type: Function,
      default: () => {},
    },
    onBrandClick: {
      type: Function,
      default: () => {},
    },
    onCategoryClick: {
      type: Function,
      default: () => {},
    },
    onProductClick: {
      type: Function,
      default: () => {},
    },
    onProductAddToCart: {
      type: Function,
      default: () => {},
    },
    request: {
      type: Function,
      required: true,
    },
    factoid: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      active: false,
      name: null,
      brand: null,
      category: null,
      product: null,
      factoidParams: null,
      params: null,
    }
  },
  async fetch() {
    try {
      const response = await this.request()
      if (!!response.product && response.product.length < 2) {
        this.$emit('create')
        return
      }
      if (response) {
        this.category = response.category
        this.name = response.name
        this.brand = response.brand
        this.product = response.product
        this.factoidParams = response.factoidParams
        this.params = response.params
        this.active = true
      }
    }
    catch (e) {
      const error = ErrorSerializer(e)
      new this.$baseError(error)
    }
    this.$emit('create')
  },
  computed: {
    innerLinkText() {
      if (this.params?.linkText)
        return this.params.linkText
      else if (this.linkText)
        return this.linkText
      else
        return null
    },
    innerLink() {
      if (this.params?.link)
        return this.params.link
      else if (this.link)
        return this.link
      else
        return null
    },
    factoidParamsParsed() {
      let tmp = {}
      if (this.factoidParams)
        tmp = { ...this.factoidParams }

      if (this.factoid.params)
        tmp = { ...tmp, ...this.factoid.params }

      return tmp
    },
  },
}
